/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Request model for editing an existing Your Food meal.
 */
export type EditYourFoodRequest = {
  /**
   * When this meal is consumed
   */
  meal_time: EditYourFoodRequest.meal_time;
  /**
   * Number of servings
   */
  portion_size: number;
  /**
   * Name of the recipe
   */
  recipe_name: string;
  /**
   * List of ingredients as strings (e.g., '200g chicken breast')
   */
  ingredients: Array<string>;
  /**
   * Cooking instructions
   */
  instructions?: Array<string> | null;
};
export namespace EditYourFoodRequest {
  /**
   * When this meal is consumed
   */
  export enum meal_time {
    BREAKFAST = "breakfast",
    LUNCH = "lunch",
    DINNER = "dinner",
    SNACK = "snack",
  }
}
